"use client";

import dynamic from "next/dynamic";

export const LazyChatBotButton = dynamic(
  () => import("./chat-bot-button").then((module) => module.ChatBotButton),
  { ssr: false }
);
